module.exports = __webpack_public_path__ + "img/franchise.0d24b871.svg";